/* eslint-disable no-debugger */
import { createSlice, createEntityAdapter } from "@reduxjs/toolkit";
import { Course } from "../../Models/Course";
import { fetchAllCourses, fetchAllCoursesChunks } from "./thunks";

const adapter = createEntityAdapter<Course>();

const initialState = adapter.getInitialState<{
  loading: boolean;
  error?: string | null;
}>({
  loading: false,
  error: null,
});

const slice = createSlice({
  name: "courses",
  initialState,
  reducers: {
    // optional local-only reducers
    upsertManyLocal: adapter.upsertMany,
    clear: (state) => {
      adapter.removeAll(state);
      state.error = null;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    // fetch
    builder
      .addCase(fetchAllCourses.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllCourses.fulfilled, (state, action) => {
        const data = action.payload as Course[];
        adapter.setAll(state, data);
        state.loading = false;
      })
      .addCase(fetchAllCourses.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "Failed to fetch courses";
      })
      .addCase(fetchAllCoursesChunks.fulfilled, (state, action) => {
        const updates = Object.entries(action.payload).map(
          ([id, properties]) => ({
            id: parseInt(id),
            changes: { ...properties, priceLoading: false },
          })
        );

        adapter.updateMany(state, updates);
      });

    // create/update/delete
    // builder.addCase(addItem.fulfilled, (state, action) => {
    //     adapter.addOne(state, action.payload);
    // });
    // builder.addCase(saveItem.fulfilled, (state, action) => {
    //     adapter.upsertOne(state, action.payload);
    // });
    // builder.addCase(removeItem.fulfilled, (state, action) => {
    //     adapter.removeOne(state, action.payload);
    // });

    // generic pending/rejected for these three
    // builder.addMatcher(
    //     isAnyOf(addItem.pending, saveItem.pending, removeItem.pending),
    //     (state) => {
    //         state.loading = true;
    //         state.error = null;
    //     }
    // );
    // builder.addMatcher(
    //     isAnyOf(addItem.rejected, saveItem.rejected, removeItem.rejected),
    //     (state, action) => {
    //         state.loading = false;
    //         state.error = action.error.message ?? "Request failed";
    //     }
    // );
    // builder.addMatcher(
    //     isAnyOf(addItem.fulfilled, saveItem.fulfilled, removeItem.fulfilled),
    //     (state) => {
    //         state.loading = false;
    //     }
    // );
  },
});

export const { upsertManyLocal, clear } = slice.actions;
export const coursesReducer = slice.reducer;
export const coursesAdapter = adapter;
